/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ForceUpdateNftOwnershipBody
 */
export interface ForceUpdateNftOwnershipBody {
    /**
     * 
     * @type {string}
     * @memberof ForceUpdateNftOwnershipBody
     */
    trackerId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ForceUpdateNftOwnershipBody
     */
    isUpdateAll: boolean;
}

/**
 * Check if a given object implements the ForceUpdateNftOwnershipBody interface.
 */
export function instanceOfForceUpdateNftOwnershipBody(value: object): value is ForceUpdateNftOwnershipBody {
    if (!('isUpdateAll' in value) || value['isUpdateAll'] === undefined) return false;
    return true;
}

export function ForceUpdateNftOwnershipBodyFromJSON(json: any): ForceUpdateNftOwnershipBody {
    return ForceUpdateNftOwnershipBodyFromJSONTyped(json, false);
}

export function ForceUpdateNftOwnershipBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ForceUpdateNftOwnershipBody {
    if (json == null) {
        return json;
    }
    return {
        
        'trackerId': json['trackerId'] == null ? undefined : json['trackerId'],
        'isUpdateAll': json['isUpdateAll'],
    };
}

export function ForceUpdateNftOwnershipBodyToJSON(json: any): ForceUpdateNftOwnershipBody {
    return ForceUpdateNftOwnershipBodyToJSONTyped(json, false);
}

export function ForceUpdateNftOwnershipBodyToJSONTyped(value?: ForceUpdateNftOwnershipBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'trackerId': value['trackerId'],
        'isUpdateAll': value['isUpdateAll'],
    };
}

